import { render, staticRenderFns } from "./IconRightBottom3.vue?vue&type=template&id=13111c2b&"
import script from "./IconRightBottom3.vue?vue&type=script&lang=js&"
export * from "./IconRightBottom3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13111c2b')) {
      api.createRecord('13111c2b', component.options)
    } else {
      api.reload('13111c2b', component.options)
    }
    module.hot.accept("./IconRightBottom3.vue?vue&type=template&id=13111c2b&", function () {
      api.rerender('13111c2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconRightBottom3.vue"
export default component.exports